import { QueryFilter } from '_metronic/helpers'
import { createListFilters, IOption } from 'app/components'
import { RegimeDispositivo, SituacaoDispositivo, TipoDispositivoGestao } from '../../core/_models'
import { criterioTextoLivre, montaBusca } from '../../core/buscaDsl'

export type DispositivosFilters = {
  texto: string
  empresa?: IOption<number>
  tipo?: IOption<TipoDispositivoGestao>
  situacao?: IOption<SituacaoDispositivo>
  regime?: IOption<RegimeDispositivo>
  fornecedor?: IOption<number>
  maleta?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<DispositivosFilters>({
  texto: '',
  empresa: undefined,
  tipo: undefined,
  situacao: undefined,
  regime: undefined,
  fornecedor: undefined,
  maleta: undefined,
})

export const CAMPOS_TEXTO_DISPOSITIVO = [
  'serie',
  'patrimonio',
  'macAddress',
  'fabricante',
  'modelo',
] as const

/** Filtros da tela → `search` da DSL do backend; só a maleta vai como parâmetro solto. */
export const consultaDosFiltros = (
  filtros: DispositivosFilters
): { search: string; filters: QueryFilter[] } => ({
  search: montaBusca(
    criterioTextoLivre(CAMPOS_TEXTO_DISPOSITIVO, filtros.texto),
    filtros.empresa && `empresa:${filtros.empresa.value}`,
    filtros.tipo && `tipo:${filtros.tipo.value}`,
    filtros.situacao && `situacao:${filtros.situacao.value}`,
    filtros.regime && `regime:${filtros.regime.value}`,
    filtros.fornecedor && `fornecedor:${filtros.fornecedor.value}`
  ),
  filters: filtros.maleta ? [{ field: 'telekit', operator: '=', value: filtros.maleta.value }] : [],
})
